import { Injectable } from "@angular/core";

import { BaseDataSource } from "../shared/_base.datasource";
import { Observable } from "rxjs";
import { Protocol } from "../../types/protocol/protocol.type";
import { ProtocolService } from "../../../services/protocol/protocol.service";

@Injectable()
export class ProtocolDatasource extends BaseDataSource<Protocol> {
    constructor(private service: ProtocolService) {
        super(service);
    }

    create(data: Protocol): Observable<boolean> {
        return this.service.create(data);
    }

    delete(id: number): Observable<boolean> {
        return this.service.delete(id);
    }

    update(data: Protocol): Observable<boolean> {
        return this.service.update(data);
    }

    getList() {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        self.service.getList(self.filter).subscribe((res) => {
            self.rows = res.rows;
            self.count = res.count;
            self.loading = false;
        });
    }
    getListInside() {
        const self = this;

        if (!self.service) {
            return;
        }

        self.loading = true;

        return self.service.getList(self.filter);
    }
}
